import { render, staticRenderFns } from "./sp-people-group-placeholder.vue?vue&type=template&id=aa2bb7fe"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports